export const SettingKey = 'SettingKey';
export const SecretKey = 'SecretKey';